import merge from 'deepmerge';

export interface IComposition {
  mergeFunction?: {
    [prop: string]: {
      where: string;
      cb: (result?: any) => void;
    },
  };
  [prop: string]: any;
}

export default function(
  composition: IComposition,
  payload: any,
) {
  const { mergeFunction } = composition;

  for (const propName in mergeFunction) {
    const exists = payload[propName];
    const { cb, where } = mergeFunction[propName];
    payload[propName] = function() {
      where === 'before' && cb.bind(this)();

      // result of existing function is passed to callback
      const result = exists && exists.bind(this)();
      where === 'after' && cb.bind(this)(result);
    };
  }

  return merge(composition, payload);
}
